import React from 'react';

import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    fontFamily: 'Raleway',
    fontSize: 18,
    fontWeight: 'bold',
    lineHeight: 0.98,
    color: '#2a149a',
    paddingBottom: 19,
  },
});

const Title = ({ classes, children }) => (
  <div className={classes.root}>{children}</div>
);

export default withStyles(styles)(Title);
